import ReactGA from "react-ga";
import PriceService from "./priceService";
import ChargeTypesService from "./chargeTypesService";
import { toJS } from "mobx";
import ChargeOrder from "models/chargeOrder";
import FuelTypeResponse from "entities/fuelTypeResponse";
import EnumService from "./enumService";

export default class GaService {
  constructor(
    private priceService: PriceService,
    private chargeTypeService: ChargeTypesService,
    private enumService: EnumService
  ) {}

  sendOrderInfo(chargeOrder: ChargeOrder) {
    const chargeOrderData = toJS(chargeOrder);

    chargeOrderData.charges.forEach((item) => {
      const price = this.priceService.chargePrice(item._chargeTypeId, item._fuelTypeId).toFixed(2);
      const valid = this.chargeTypeService.chargeTypes.find((t) => t.id === item._chargeTypeId)?.validFor;
      const fuelTypes = this.enumService.values("fuel_types") as FuelTypeResponse[];
      const fuelType = fuelTypes.find((t) => t.id.toString() === item._fuelTypeId)?.name;
      const product = `${valid} - ${fuelType}`;

      ReactGA.plugin.execute("ecommerce", "addItem", {
        id: chargeOrderData.id,
        name: product,
        sku: product,
        price,
        currency: "CZK",
        quantity: item.licensePlates ? item.licensePlates.length : 1,
      });
    });

    const revenue = this.priceService.grandTotal(chargeOrderData).toFixed(2);

    ReactGA.plugin.execute("ecommerce", "addTransaction", {
      id: chargeOrderData.id,
      affiliation: chargeOrderData.paymentType,
      revenue,
      currency: "CZK",
      quantity: 1,
    });

    ReactGA.plugin.execute("ecommerce", "send", {});
  }
}
